import { z } from 'zod'
import { ProductSubItemStatus } from '~/enums/product-sub-item-status'
import { apiResponseSchema } from '../helper/api-response-schema'

/** 產品子網頁類目 */
export const productSubItemSchema = z.object({
  /** 產品子網頁分類 ID */
  psiID: z.number().optional(),
  /** 產品子類目 ID */
  psID: z.number().optional(),
  /** 名稱（中文） */
  psiNameZh: z.string().optional(),
  /** 名稱（英文） */
  psiNameEn: z.string().optional(),
  status: z.nativeEnum(ProductSubItemStatus)
})

export const productSubItemResponseSchema =
  apiResponseSchema(productSubItemSchema)

export const productSubItemListResponseSchema = apiResponseSchema(
  productSubItemSchema.array()
)

export interface ProductSubItem extends z.infer<typeof productSubItemSchema> {}
export interface ProductSubItemResponse
  extends z.infer<typeof productSubItemResponseSchema> {}
export interface ProductSubItemListResponse
  extends z.infer<typeof productSubItemListResponseSchema> {}

export class ProductSubItem {
  constructor() {
    return {
      psiID: undefined,
      psID: undefined,
      psiNameZh: '',
      psiNameEn: '',
      status: ProductSubItemStatus.EMPTY
    }
  }
}
